module.exports = __webpack_public_path__ + "media/icons/document-88816a98.svg";